import type { JSX } from 'react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

/**
 * Placeholder tab — Phase 9 ships the structural skeleton; the real
 * logsheet rollup arrives in Phase 12.
 */
export interface SiteLogsheetStatsTabProps {
  readonly siteId: number;
}

export function SiteLogsheetStatsTab({ siteId }: SiteLogsheetStatsTabProps): JSX.Element {
  return (
    <Alert variant="default" data-testid="site-logsheets-tab" data-site-id={siteId}>
      <AlertTitle>Logsheet stats</AlertTitle>
      <AlertDescription>
        Phase 12 — Logsheet Maker flow will populate this tab. Counts and rollups will display once
        the logsheet pipeline ships.
      </AlertDescription>
    </Alert>
  );
}
